module.exports = __webpack_public_path__ + "img/bg-l.131cadaf.svg";